module.exports = __webpack_public_path__ + "@/assets/img/user.3ac23b90.svg";